export default __webpack_public_path__ + "static/media/about-gallery.75e573e1.jpg";